import mountain from "../images/mountain.png";
import no_entry from "../images/no_entry.png";
import parking from "../images/parking.png";
import park_bench from "../images/park_bench.png";
import picnic from "../images/picnic.png";
import DEA from "../images/DEA.png";
import Tenda from "../images/Tenda.png";
import Refugi from "../images/Refugi.png";
import climbing from "../images/climbing.png";

export default {
	mountain: mountain,
	no_entry: no_entry,
	parking: parking,
	park_bench: park_bench,
    picnic: picnic,
    DEA: DEA,
    Refugi: Refugi,
    Tenda: Tenda,
    climbing: climbing
}